/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611041809-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqSystemApiClass {
 
   constructor() {}

  /**
   * @summary Create an Add-on Tool
  */
  public createAddOnTool(
    body: models.AddOnToolInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/addOnTools`;
    const urlTemplate = `${baseUrl}/system/configuration/addOnTools`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AddOnToolOutputV1>;
  }

  /**
   * @summary Delete an Add-on Tool
   * @param {string} id - ID of the Add-on Tool to delete
  */
  public deleteAddOnTool(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/addOnTools/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/system/configuration/addOnTools/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Disable a licensed feature until the next server shutdown.
   * @param {string} name - The name of the licensed feature
  */
  public disableLicensedFeature(
    {
      name
    } : {
      name: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (name === null || name === undefined) {
      throw new Error("'name' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/license/features/${encodeURIComponent(String(name))}`
      .replace('{name}', encodeURIComponent(String(name)));
    const urlTemplate = `${baseUrl}/system/license/features/{name}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Re-enable a licensed feature that was previously disabled. If the feature does not have a valid license or was not previously disabled, this will do nothing.
   * @param {string} name - The name of the licensed feature
  */
  public enableLicensedFeature(
    {
      name
    } : {
      name: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (name === null || name === undefined) {
      throw new Error("'name' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/license/features/${encodeURIComponent(String(name))}`
      .replace('{name}', encodeURIComponent(String(name)));
    const urlTemplate = `${baseUrl}/system/license/features/{name}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Gets an Add-on Tool.
   * @param {string} id - ID of the Add-on Tool to get
  */
  public getAddOnTool(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/addOnTools/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/system/configuration/addOnTools/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AddOnToolOutputV1>;
  }

  /**
   * @summary Gets a list of all Add-on Tools.
  */
  public getAddOnTools(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/addOnTools`;
    const urlTemplate = `${baseUrl}/system/configuration/addOnTools`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.GetAddOnToolsOutputV1>;
  }

  /**
   * @summary Get the system administrator's contact information
  */
  public getAdministratorContactInformation(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/contactInformation`;
    const urlTemplate = `${baseUrl}/system/contactInformation`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AdministratorContactInformationV1>;
  }

  /**
   * @summary Used to retrieve the value of the Seeq server agent.key. This method is deprecated; use Agent provisioning instead.
   * @deprecated Use Agent provisioning instead.
  */
  public getAgentKey(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/agentKey`;
    const urlTemplate = `${baseUrl}/system/agentKey`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AgentKeyOutputV1>;
  }

  /**
   * @summary Used to determine the precise revision of this Seeq build
  */
  public getBuildInfo(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/build-info`;
    const urlTemplate = `${baseUrl}/system/build-info`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ServerBuildInfoOutputV1>;
  }

  /**
   * @summary Get the list of configuration options and their details, including the current and default value
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {string} [configurationFilter] - Only return configuration options whose paths start with this string
  */
  public getConfigurationOptions(
    {
      offset,
      limit,
      configurationFilter
    } : {
      offset?: number,
      limit?: number,
      configurationFilter?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/options`;
    const urlTemplate = `${baseUrl}/system/configuration/options`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['configurationFilter']: configurationFilter
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ConfigurationOutputV1>;
  }

  /**
   * @summary Download installer images
   * @param {string} fileName - The name of the installation image
  */
  public getInstallerFile(
    {
      fileName
    } : {
      fileName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (fileName === null || fileName === undefined) {
      throw new Error("'fileName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/installer/${encodeURIComponent(String(fileName))}`
      .replace('{fileName}', encodeURIComponent(String(fileName)));
    const urlTemplate = `${baseUrl}/system/installer/{fileName}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Get the current server license, if any
  */
  public getLicense(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/license`;
    const urlTemplate = `${baseUrl}/system/license`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.LicenseStatusOutputV1>;
  }

  /**
   * @summary Used to determine server readiness; available without authentication
  */
  public getOpenPing(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/open-ping`;
    const urlTemplate = `${baseUrl}/system/open-ping`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Used to determine server readiness, but only available with authentication
  */
  public getPing(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/ping`;
    const urlTemplate = `${baseUrl}/system/ping`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get the release notes for the upcoming version, the currently installed version, and for the recently installed versions
  */
  public getReleaseNotes(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/release-notes`;
    const urlTemplate = `${baseUrl}/system/release-notes`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ReleaseNotesOutputV1>;
  }

  /**
   * @summary Get a list of the emails that have been sent by the server in the past 7 days, up to a maximum of 10,000. Note that non-administrators will only see emails from notifications they manage.
  */
  public getSentEmails(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/sent-emails`;
    const urlTemplate = `${baseUrl}/system/sent-emails`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.SentEmailsListOutputV1>;
  }

  /**
   * @summary Used to determine the current load the server is experiencing, where a high load indicates a lot of concurrent activity within the server.
  */
  public getServerLoad(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/server-load`;
    const urlTemplate = `${baseUrl}/system/server-load`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ServerLoadOutputV1>;
  }

  /**
   * @summary Used to determine server readiness, telemetry configuration, and other server variables
   * @param {boolean} [includeInternal=false] - whether to include internal statuses
  */
  public getServerStatus(
    {
      includeInternal
    } : {
      includeInternal?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/server-status`;
    const urlTemplate = `${baseUrl}/system/server-status`;

    const queryParams = {
      ['includeInternal']: includeInternal
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ServerStatusOutputV1>;
  }

  /**
   * @summary Get list of commonly used and supported units
  */
  public getSupportedUnits(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/supportedUnits`;
    const urlTemplate = `${baseUrl}/system/supportedUnits`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.SupportedUnitsOutputV1>;
  }

  /**
   * @summary Get a threaddump of the server as a logfile and send the information to the logs
   * @param {number} [maxFrameCount=50] - Maximum frames to output for each thread.
  */
  public getThreadState(
    {
      maxFrameCount
    } : {
      maxFrameCount?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/threadState.log`;
    const urlTemplate = `${baseUrl}/system/threadState.log`;

    const queryParams = {
      ['maxFrameCount']: maxFrameCount
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Import a license file
   * @param {string} [file]
  */
  public importLicense(
    {
      file
    } : {
      file?: File
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/license`;
    const urlTemplate = `${baseUrl}/system/license`;


    const formData = new FormData();
    formData.append('file', file as File, file?.name);

    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.LicenseImporterOutputV1>;

  }

  /**
   * @summary Set the system administrator's contact information
  */
  public setAdministratorContactInformation(
    body: models.AdministratorContactInformationV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/contactInformation`;
    const urlTemplate = `${baseUrl}/system/contactInformation`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Write one or more configuration options
  */
  public setConfigurationOptions(
    body: models.ConfigurationInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/options`;
    const urlTemplate = `${baseUrl}/system/configuration/options`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ConfigurationOutputV1>;
  }

  /**
   * @summary Translate an input list to canonical unit of measure strings
  */
  public uOMs(
    body: models.UnitsOfMeasureBatchInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/uoms`;
    const urlTemplate = `${baseUrl}/system/uoms`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UnitsOfMeasureOutputV1>;
  }

  /**
   * @summary Update the attributes of an Add-on Tool
   * @param {string} id - ID of the Add-on Tool to update
  */
  public updateAddOnTool(
    body: models.AddOnToolInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/configuration/addOnTools/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/system/configuration/addOnTools/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AddOnToolOutputV1>;
  }

}


export const sqSystemApi = new sqSystemApiClass();

export type sqSystemApiEndpoints = {
  'createAddOnTool': {
    method: 'post';
    path: '/system/configuration/addOnTools';
    response: models.AddOnToolOutputV1;
  };
  'deleteAddOnTool': {
    method: 'delete';
    path: '/system/configuration/addOnTools/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'disableLicensedFeature': {
    method: 'delete';
    path: '/system/license/features/${encodeURIComponent(String(name))}';
    response: {};
  };
  'enableLicensedFeature': {
    method: 'post';
    path: '/system/license/features/${encodeURIComponent(String(name))}';
    response: {};
  };
  'getAddOnTool': {
    method: 'get';
    path: '/system/configuration/addOnTools/${encodeURIComponent(String(id))}';
    response: models.AddOnToolOutputV1;
  };
  'getAddOnTools': {
    method: 'get';
    path: '/system/configuration/addOnTools';
    response: models.GetAddOnToolsOutputV1;
  };
  'getAdministratorContactInformation': {
    method: 'get';
    path: '/system/contactInformation';
    response: models.AdministratorContactInformationV1;
  };
  'getAgentKey': {
    method: 'get';
    path: '/system/agentKey';
    response: models.AgentKeyOutputV1;
  };
  'getBuildInfo': {
    method: 'get';
    path: '/system/build-info';
    response: models.ServerBuildInfoOutputV1;
  };
  'getConfigurationOptions': {
    method: 'get';
    path: '/system/configuration/options';
    response: models.ConfigurationOutputV1;
  };
  'getInstallerFile': {
    method: 'get';
    path: '/system/installer/${encodeURIComponent(String(fileName))}';
    response: string;
  };
  'getLicense': {
    method: 'get';
    path: '/system/license';
    response: models.LicenseStatusOutputV1;
  };
  'getOpenPing': {
    method: 'get';
    path: '/system/open-ping';
    response: models.StatusMessageBase;
  };
  'getPing': {
    method: 'get';
    path: '/system/ping';
    response: models.StatusMessageBase;
  };
  'getReleaseNotes': {
    method: 'get';
    path: '/system/release-notes';
    response: models.ReleaseNotesOutputV1;
  };
  'getSentEmails': {
    method: 'get';
    path: '/system/sent-emails';
    response: models.SentEmailsListOutputV1;
  };
  'getServerLoad': {
    method: 'get';
    path: '/system/server-load';
    response: models.ServerLoadOutputV1;
  };
  'getServerStatus': {
    method: 'get';
    path: '/system/server-status';
    response: models.ServerStatusOutputV1;
  };
  'getSupportedUnits': {
    method: 'get';
    path: '/system/supportedUnits';
    response: models.SupportedUnitsOutputV1;
  };
  'getThreadState': {
    method: 'get';
    path: '/system/threadState.log';
    response: string;
  };
  'importLicense': {
    method: 'post';
    path: '/system/license';
    response: models.LicenseImporterOutputV1;
  };
  'setAdministratorContactInformation': {
    method: 'post';
    path: '/system/contactInformation';
    response: models.StatusMessageBase;
  };
  'setConfigurationOptions': {
    method: 'post';
    path: '/system/configuration/options';
    response: models.ConfigurationOutputV1;
  };
  'uOMs': {
    method: 'post';
    path: '/system/uoms';
    response: models.UnitsOfMeasureOutputV1;
  };
  'updateAddOnTool': {
    method: 'post';
    path: '/system/configuration/addOnTools/${encodeURIComponent(String(id))}';
    response: models.AddOnToolOutputV1;
  };
};

type ApiCreateAddOnToolResponse = models.AddOnToolOutputV1;
type ApicreateAddOnToolMutationParams = Parameters<typeof sqSystemApi.createAddOnTool> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.createAddOnTool>;
type ApicreateAddOnToolMutationVariables = models.AddOnToolInputV1;

export function useApiCreateAddOnToolMutation(
  options?: Omit<UseMutationOptions<ApiCreateAddOnToolResponse, AxiosError<SeeqErrorData>,
    ApicreateAddOnToolMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateAddOnToolResponse, AxiosError<SeeqErrorData>,
  ApicreateAddOnToolMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateAddOnToolMutationVariables) =>
      sqSystemApi.createAddOnTool(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteAddOnToolResponse = models.StatusMessageBase;
type ApideleteAddOnToolMutationParams = Parameters<typeof sqSystemApi.deleteAddOnTool> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.deleteAddOnTool>;

export function useApiDeleteAddOnToolMutation(
  options?: Omit<UseMutationOptions<ApiDeleteAddOnToolResponse, AxiosError<SeeqErrorData>,
    ApideleteAddOnToolMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiDeleteAddOnToolResponse, AxiosError<SeeqErrorData>,
  ApideleteAddOnToolMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApideleteAddOnToolMutationParams) =>
      sqSystemApi.deleteAddOnTool(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDisableLicensedFeatureResponse = {};
type ApidisableLicensedFeatureMutationParams = Parameters<typeof sqSystemApi.disableLicensedFeature> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.disableLicensedFeature>;

export function useApiDisableLicensedFeatureMutation(
  options?: Omit<UseMutationOptions<ApiDisableLicensedFeatureResponse, AxiosError<SeeqErrorData>,
    ApidisableLicensedFeatureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiDisableLicensedFeatureResponse, AxiosError<SeeqErrorData>,
  ApidisableLicensedFeatureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApidisableLicensedFeatureMutationParams) =>
      sqSystemApi.disableLicensedFeature(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiEnableLicensedFeatureResponse = {};
type ApienableLicensedFeatureMutationParams = Parameters<typeof sqSystemApi.enableLicensedFeature> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.enableLicensedFeature>;

export function useApiEnableLicensedFeatureMutation(
  options?: Omit<UseMutationOptions<ApiEnableLicensedFeatureResponse, AxiosError<SeeqErrorData>,
    ApienableLicensedFeatureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiEnableLicensedFeatureResponse, AxiosError<SeeqErrorData>,
  ApienableLicensedFeatureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApienableLicensedFeatureMutationParams) =>
      sqSystemApi.enableLicensedFeature(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetAddOnToolResponse = models.AddOnToolOutputV1;
export function GetAddOnToolQueryKey(
  params: Parameters<typeof sqSystemApi.getAddOnTool>[0],
) {
  return ['sqSystemApi', 'getAddOnTool', params] as const;
}

export function useApiGetAddOnToolQuery(
  params: Parameters<typeof sqSystemApi.getAddOnTool>[0],
  options?: Omit<UseQueryOptions<ApiGetAddOnToolResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAddOnToolResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAddOnToolQueryKey(params),
    queryFn: () =>
      sqSystemApi.getAddOnTool(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAddOnToolsResponse = models.GetAddOnToolsOutputV1;
export function GetAddOnToolsQueryKey(
) {
  return ['sqSystemApi', 'getAddOnTools'] as const;
}

export function useApiGetAddOnToolsQuery(
  options?: Omit<UseQueryOptions<ApiGetAddOnToolsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAddOnToolsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAddOnToolsQueryKey(),
    queryFn: () =>
      sqSystemApi.getAddOnTools(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAdministratorContactInformationResponse = models.AdministratorContactInformationV1;
export function GetAdministratorContactInformationQueryKey(
) {
  return ['sqSystemApi', 'getAdministratorContactInformation'] as const;
}

export function useApiGetAdministratorContactInformationQuery(
  options?: Omit<UseQueryOptions<ApiGetAdministratorContactInformationResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAdministratorContactInformationResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAdministratorContactInformationQueryKey(),
    queryFn: () =>
      sqSystemApi.getAdministratorContactInformation(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAgentKeyResponse = models.AgentKeyOutputV1;
export function GetAgentKeyQueryKey(
) {
  return ['sqSystemApi', 'getAgentKey'] as const;
}

export function useApiGetAgentKeyQuery(
  options?: Omit<UseQueryOptions<ApiGetAgentKeyResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAgentKeyResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAgentKeyQueryKey(),
    queryFn: () =>
      sqSystemApi.getAgentKey(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetBuildInfoResponse = models.ServerBuildInfoOutputV1;
export function GetBuildInfoQueryKey(
) {
  return ['sqSystemApi', 'getBuildInfo'] as const;
}

export function useApiGetBuildInfoQuery(
  options?: Omit<UseQueryOptions<ApiGetBuildInfoResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetBuildInfoResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetBuildInfoQueryKey(),
    queryFn: () =>
      sqSystemApi.getBuildInfo(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConfigurationOptionsResponse = models.ConfigurationOutputV1;
export function GetConfigurationOptionsQueryKey(
  params: Parameters<typeof sqSystemApi.getConfigurationOptions>[0],
) {
  return ['sqSystemApi', 'getConfigurationOptions', params] as const;
}

export function useApiGetConfigurationOptionsQuery(
  params: Parameters<typeof sqSystemApi.getConfigurationOptions>[0],
  options?: Omit<UseQueryOptions<ApiGetConfigurationOptionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetConfigurationOptionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetConfigurationOptionsQueryKey(params),
    queryFn: () =>
      sqSystemApi.getConfigurationOptions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstallerFileResponse = string;
export function GetInstallerFileQueryKey(
  params: Parameters<typeof sqSystemApi.getInstallerFile>[0],
) {
  return ['sqSystemApi', 'getInstallerFile', params] as const;
}

export function useApiGetInstallerFileQuery(
  params: Parameters<typeof sqSystemApi.getInstallerFile>[0],
  options?: Omit<UseQueryOptions<ApiGetInstallerFileResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetInstallerFileResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetInstallerFileQueryKey(params),
    queryFn: () =>
      sqSystemApi.getInstallerFile(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetLicenseResponse = models.LicenseStatusOutputV1;
export function GetLicenseQueryKey(
) {
  return ['sqSystemApi', 'getLicense'] as const;
}

export function useApiGetLicenseQuery(
  options?: Omit<UseQueryOptions<ApiGetLicenseResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetLicenseResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetLicenseQueryKey(),
    queryFn: () =>
      sqSystemApi.getLicense(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetOpenPingResponse = models.StatusMessageBase;
export function GetOpenPingQueryKey(
) {
  return ['sqSystemApi', 'getOpenPing'] as const;
}

export function useApiGetOpenPingQuery(
  options?: Omit<UseQueryOptions<ApiGetOpenPingResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetOpenPingResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetOpenPingQueryKey(),
    queryFn: () =>
      sqSystemApi.getOpenPing(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPingResponse = models.StatusMessageBase;
export function GetPingQueryKey(
) {
  return ['sqSystemApi', 'getPing'] as const;
}

export function useApiGetPingQuery(
  options?: Omit<UseQueryOptions<ApiGetPingResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetPingResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetPingQueryKey(),
    queryFn: () =>
      sqSystemApi.getPing(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetReleaseNotesResponse = models.ReleaseNotesOutputV1;
export function GetReleaseNotesQueryKey(
) {
  return ['sqSystemApi', 'getReleaseNotes'] as const;
}

export function useApiGetReleaseNotesQuery(
  options?: Omit<UseQueryOptions<ApiGetReleaseNotesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetReleaseNotesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetReleaseNotesQueryKey(),
    queryFn: () =>
      sqSystemApi.getReleaseNotes(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSentEmailsResponse = models.SentEmailsListOutputV1;
export function GetSentEmailsQueryKey(
) {
  return ['sqSystemApi', 'getSentEmails'] as const;
}

export function useApiGetSentEmailsQuery(
  options?: Omit<UseQueryOptions<ApiGetSentEmailsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSentEmailsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSentEmailsQueryKey(),
    queryFn: () =>
      sqSystemApi.getSentEmails(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetServerLoadResponse = models.ServerLoadOutputV1;
export function GetServerLoadQueryKey(
) {
  return ['sqSystemApi', 'getServerLoad'] as const;
}

export function useApiGetServerLoadQuery(
  options?: Omit<UseQueryOptions<ApiGetServerLoadResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetServerLoadResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetServerLoadQueryKey(),
    queryFn: () =>
      sqSystemApi.getServerLoad(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetServerStatusResponse = models.ServerStatusOutputV1;
export function GetServerStatusQueryKey(
  params: Parameters<typeof sqSystemApi.getServerStatus>[0],
) {
  return ['sqSystemApi', 'getServerStatus', params] as const;
}

export function useApiGetServerStatusQuery(
  params: Parameters<typeof sqSystemApi.getServerStatus>[0],
  options?: Omit<UseQueryOptions<ApiGetServerStatusResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetServerStatusResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetServerStatusQueryKey(params),
    queryFn: () =>
      sqSystemApi.getServerStatus(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSupportedUnitsResponse = models.SupportedUnitsOutputV1;
export function GetSupportedUnitsQueryKey(
) {
  return ['sqSystemApi', 'getSupportedUnits'] as const;
}

export function useApiGetSupportedUnitsQuery(
  options?: Omit<UseQueryOptions<ApiGetSupportedUnitsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSupportedUnitsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSupportedUnitsQueryKey(),
    queryFn: () =>
      sqSystemApi.getSupportedUnits(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetThreadStateResponse = string;
export function GetThreadStateQueryKey(
  params: Parameters<typeof sqSystemApi.getThreadState>[0],
) {
  return ['sqSystemApi', 'getThreadState', params] as const;
}

export function useApiGetThreadStateQuery(
  params: Parameters<typeof sqSystemApi.getThreadState>[0],
  options?: Omit<UseQueryOptions<ApiGetThreadStateResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetThreadStateResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetThreadStateQueryKey(params),
    queryFn: () =>
      sqSystemApi.getThreadState(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiImportLicenseResponse = models.LicenseImporterOutputV1;
type ApiimportLicenseMutationParams = Parameters<typeof sqSystemApi.importLicense> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.importLicense>;

export function useApiImportLicenseMutation(
  options?: Omit<UseMutationOptions<ApiImportLicenseResponse, AxiosError<SeeqErrorData>,
    ApiimportLicenseMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiImportLicenseResponse, AxiosError<SeeqErrorData>,
  ApiimportLicenseMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiimportLicenseMutationParams) =>
      sqSystemApi.importLicense(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetAdministratorContactInformationResponse = models.StatusMessageBase;
type ApisetAdministratorContactInformationMutationParams = Parameters<typeof sqSystemApi.setAdministratorContactInformation> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.setAdministratorContactInformation>;
type ApisetAdministratorContactInformationMutationVariables = models.AdministratorContactInformationV1;

export function useApiSetAdministratorContactInformationMutation(
  options?: Omit<UseMutationOptions<ApiSetAdministratorContactInformationResponse, AxiosError<SeeqErrorData>,
    ApisetAdministratorContactInformationMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetAdministratorContactInformationResponse, AxiosError<SeeqErrorData>,
  ApisetAdministratorContactInformationMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApisetAdministratorContactInformationMutationVariables) =>
      sqSystemApi.setAdministratorContactInformation(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiSetConfigurationOptionsResponse = models.ConfigurationOutputV1;
type ApisetConfigurationOptionsMutationParams = Parameters<typeof sqSystemApi.setConfigurationOptions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.setConfigurationOptions>;
type ApisetConfigurationOptionsMutationVariables = models.ConfigurationInputV1;

export function useApiSetConfigurationOptionsMutation(
  options?: Omit<UseMutationOptions<ApiSetConfigurationOptionsResponse, AxiosError<SeeqErrorData>,
    ApisetConfigurationOptionsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetConfigurationOptionsResponse, AxiosError<SeeqErrorData>,
  ApisetConfigurationOptionsMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApisetConfigurationOptionsMutationVariables) =>
      sqSystemApi.setConfigurationOptions(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUOMsResponse = models.UnitsOfMeasureOutputV1;
/** Named request inputs; transport overrides do not identify cached data. */
type ApiUOMsQueryParams = {
  body: models.UnitsOfMeasureBatchInputV1;
};

/** Omit inputs or individual fields to match multiple cached requests during invalidation. */
type ApiUOMsQueryKeyParams = {
  [K in keyof ApiUOMsQueryParams]?: Partial<ApiUOMsQueryParams[K]>;
};

export function UOMsQueryKey(input: ApiUOMsQueryKeyParams) {
  return ['sqSystemApi', 'uOMs', input] as const;
}

/** A safe, idempotent read transported as POST. The cache stores the unmodified SDK response payload. */
export function useApiUOMsQuery<TData = ApiUOMsResponse>(
  input: ApiUOMsQueryParams,
  options?: Omit<UseQueryOptions<ApiUOMsResponse, AxiosError<SeeqErrorData>, TData>, 'queryKey' | 'queryFn'> & {
    axiosInstance?: AxiosInstance;
    silent?: boolean;
  },
): UseQueryResult<TData, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: UOMsQueryKey(input),
    queryFn: () => sqSystemApi.uOMs(
      input.body,
      
      
      requestConfig,
    ).then((response) => response.data),
    ...queryOptions,
  });
}
type ApiuOMsMutationParams = Parameters<typeof sqSystemApi.uOMs> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.uOMs>;
type ApiuOMsMutationVariables = models.UnitsOfMeasureBatchInputV1;

export function useApiUOMsMutation(
  options?: Omit<UseMutationOptions<ApiUOMsResponse, AxiosError<SeeqErrorData>,
    ApiuOMsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUOMsResponse, AxiosError<SeeqErrorData>,
  ApiuOMsMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiuOMsMutationVariables) =>
      sqSystemApi.uOMs(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUpdateAddOnToolResponse = models.AddOnToolOutputV1;
type ApiupdateAddOnToolMutationParams = Parameters<typeof sqSystemApi.updateAddOnTool> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSystemApi.updateAddOnTool>;

export function useApiUpdateAddOnToolMutation(
  options?: Omit<UseMutationOptions<ApiUpdateAddOnToolResponse, AxiosError<SeeqErrorData>,
    ApiupdateAddOnToolMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateAddOnToolResponse, AxiosError<SeeqErrorData>,
  ApiupdateAddOnToolMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateAddOnToolMutationParams) =>
      sqSystemApi.updateAddOnTool(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
